import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseKnowledgeBaseDocument } from 'entities/KnowledgeBase'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseKnowledgeBaseDocument) => void

export const useEventKnowledgeBaseDocumentUpdated = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.KnowledgeBaseDocumentUpdated, handler), [])
}
